import CRUDServiceOperations from "./CRUDServiceOperations";
class LifeCycleHistoryLogService extends CRUDServiceOperations {
  getEntitiesUrl = () => {
    return "";
  };
}
export default LifeCycleHistoryLogService;
